const countPlaceholders = (markup) => {
  let count = 0
  if (markup.indexOf("__id__") >= 0) count += 1
  if (markup.indexOf("__display__") >= 0) count += 1
  return count
}

export default countPlaceholders
